import classNames from 'classnames'
import styles from './RadioButton.module.css'
import { Icon } from '../Icon'
import { type MouseEventHandler, forwardRef, useId } from 'react'
import { RadioButtonProps } from './types'

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(function RadioButton(
  {
    children,
    disabled_,
    checked,
    'classNames': externalStyles,
    disabled,
    'aria-disabled': ariaDisabled_,
    fullWidth,
    ...props
  },
  ref
) {
  const { value, name, id: id_ } = props
  const generatedId = useId()
  const id = id_ || name || generatedId
  const composedId = `${id}-${String(value)}`
  const inputDisabled = disabled_ || disabled
  const ariaDisabled = ariaDisabled_ || inputDisabled

  // We opted for nesting the input because there were screen reader issues otherwise. Could be revisited.
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <label
      htmlFor={composedId}
      className={classNames(styles.radioContainer, externalStyles?.container, {
        [styles.disabledLabel!]: inputDisabled,
        ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
        ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
      })}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onClick={props.onClick as MouseEventHandler<any> | undefined}
    >
      <div
        className={classNames(styles.radioWrapper, {
          ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
          ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
        })}
      >
        <div className={styles.radio}>
          <input
            {...props}
            id={composedId}
            type="radio"
            ref={ref}
            aria-disabled={ariaDisabled}
            aria-checked={checked}
            disabled={disabled_}
          />
          <Icon name="radio" size="500" className={classNames(styles.radioCircle, externalStyles?.radioCircle)} />
        </div>
        <div className={classNames(styles.label, externalStyles?.label)}>{children}</div>
      </div>
    </label>
  )
})

export default RadioButton
